const fieldsInfo = {};

const tabs = [
  {
    title: 'Información General',
    fields: [
      'serie',
      'numero_de_calcomania',
      'clave_nacional',
      'unidad_de_recaudacion',
      'observaciones',
    ],
  },
  {
    title: 'Información del Remolque',
    fields: [
      'es_nacional',
      'pais',
      'es_foraneo',
      'marca',
      'modelo',
      'linea',
      'tipo',
      'servicio',
      'capacidad_de_carga',
      'eje_direccional',
      'eje_motriz',
      'eje_arrastre',
      'ancho_del_remolque',
      'alto_del_remolque',
      'largo_del_remolque',
      'color_del_remolque',
      'color_secundario',
      'capacidad_de_personas',
      'capacidad_de_combustible',
      'uso_del_remolque',
      'peso_del_remolque',
      'numero_de_ruedas',
      'estatus_del_vehiculo',
    ],
  },
  {
    title: 'Facturación',
    fields: [
      'clave_del_documento_de_regularizacion',
      'tramite_del_remolque',
      'importe_de_la_factura',
      'fecha_de_la_factura',
      'numero_de_factura',
      'registro_publico_vehicular',
      'observaciones_de_factura',
    ],
  },
];

const configs = {
  // Información General
  serie: {
    formItemProps: {
      label: 'Serial',
      required: true,
    },
    controlProps: {
      maxLength: 40,
    },
  },
  numero_de_calcomania: {
    formItemProps: {
      label: 'Número de Calcomanía',
    },
  },
  clave_nacional: {
    formItemProps: {
      label: 'Clave Nacional',
    },
  },
  unidad_de_recaudacion: {
    formItemProps: {
      label: 'Unidad Recaudadora',
      required: true,
    },
  },
  observaciones: {
    formItemProps: {
      label: 'Observaciones',
    },
  },
  // Información del remolque
  es_nacional: {
    formItemProps: {
      label: '¿Es Nacional?',
    },
    defaultValue: true,
    hideOnTruty: ['pais'],
  },
  pais: {
    fkListIsPaginated: true,
    formItemProps: {
      label: 'Pais',
      required: true,
    },
  },
  es_foraneo: {
    formItemProps: {
      label: '¿Es Foraneo?',
    },
  },
  marca: {
    fkListIsPaginated: true,
    formItemProps: {
      label: 'Marca del remolque',
    },
  },
  modelo: {
    formItemProps: {
      label: 'Modelo',
      tooltip: 'Año del vehículo',
    },
  },
  linea: {
    formItemProps: {
      label: 'Línea',
    },
  },
  tipo: {
    formItemProps: {
      label: 'Tipo de Remolque',
    },
  },
  servicio: {
    formItemProps: {
      label: 'Servicio',
      required: true,
    },
    controlProps: {
      labelProp: 'nombre',
    },
  },
  capacidad_de_carga: {
    formItemProps: {
      label: 'Capacidad en peso',
    },
  },
  eje_direccional: {
    formItemProps: {
      label: 'Eje Direccional',
    },
  },
  eje_motriz: {
    formItemProps: {
      label: 'Eje Motriz',
    },
  },
  eje_arrastre: {
    formItemProps: {
      label: 'Eje de Arrastre',
    },
  },
  ancho_del_remolque: {
    formItemProps: {
      label: 'Ancho del Remolque',
    },
  },
  alto_del_remolque: {
    formItemProps: {
      label: 'Altura del Remolque',
    },
  },
  largo_del_remolque: {
    formItemProps: {
      label: 'Largo del Remolque',
    },
  },
  color_del_remolque: {
    formItemProps: {
      label: 'Color',
      required: true,
    },
  },
  color_secundario: {
    formItemProps: {
      label: 'Color Secundario',
    },
  },
  capacidad_de_personas: {
    formItemProps: {
      label: 'Capacidad de personas',
    },
  },
  capacidad_de_combustible: {
    formItemProps: {
      label: 'Capacidad del Tanque',
      tooltip: 'Capacidad en litros',
    },
  },
  uso_del_remolque: {
    formItemProps: {
      label: 'Uso del Remolque',
      required: true,
    },
  },
  peso_del_remolque: {
    formItemProps: {
      label: 'Peso del Remolque',
    },
  },
  numero_de_ruedas: {
    formItemProps: {
      label: 'Número de ruedas',
      required: true,
    },
  },
  estatus_del_vehiculo: {
    formItemProps: {
      label: 'Estatus del Remolque',
    },
    controlProps: {
      labelProp: 'nombre',
    },
  },
  // Facturación
  clave_del_documento_de_regularizacion: {
    formItemProps: {
      label: 'Clave de Documento',
    },
  },
  tramite_del_remolque: {
    formItemProps: {
      label: 'Tramite del Remolque',
      required: false,
    },
  },
  importe_de_la_factura: {
    formItemProps: {
      label: 'Importe de la factura',
    },
  },
  fecha_de_la_factura: {
    formItemProps: {
      label: 'Importe de la factura',
    },
  },
  numero_de_factura: {
    formItemProps: {
      label: 'Número de factura',
    },
  },
  registro_publico_vehicular: {
    formItemProps: {
      label: 'Registro Público Vehicular',
    },
    controlProps: {
      maxLength: 17,
    },
  },
  observaciones_de_factura: {
    formItemProps: {
      label: 'Observaciones de Factura',
    },
  },
};

const forbiddenProps = [
  'numero_de_placa_vigente',
];

export default {
  configs,
  forbiddenProps,
  fieldsInfo,
  tabs,
};
